module.exports = __webpack_public_path__ + "images/26960b2c6cee7943e636f0dcbba33f10-none_badge.png";